const env = process.env.TARGET_ENV
export const promoCardsIndex = `${env}_promo_cards`
export const productsIndex = `${env}_products_v2`

// Maps an index name to a list of supported countries for that index
const indexToCountries = {
  NA_production_products_v2: ['us', 'ca'],
  JP_production_products_v2: ['jp'],
}

// Inverts indexToCountries so that each single country maps to its specific index name
// { us: 'production_products_NA_v2', br: 'production_products_SA_v2', ... }
export const countryToIndexName = Object.keys(indexToCountries).reduce((obj, indexName) => {
  return indexToCountries[indexName].reduce((acc, country) => {
    return {
      ...acc,
      [country]: indexName,
    }
  }, obj)
}, {})

export function getIndexNames(country) {
  // only prod supports regions
  if (process.env.TARGET_ENV !== 'production') {
    return {
      promoCards: promoCardsIndex,
      products: productsIndex,
    }
  }

  return {
    promoCards: promoCardsIndex,
    products: countryToIndexName[country] || productsIndex,
  }
}
